import React, { memo, useContext, useEffect } from "react";
import { Data } from "../App";

function Modal() {
  const { filteredList, modal, setModal, modalCurrent, setModalCurrent } =
    useContext(Data);

  const handleKeyDown = (event) => {
    // 矢印キーの判定
    if (event.keyCode === 37 || event.keyCode === 65) {
      // 左矢印キーが押された場合の処理
      document.querySelector(".prev").click();
    } else if (event.keyCode === 39 || event.keyCode === 68) {
      // 右矢印キーが押された場合の処理
      document.querySelector(".next").click();
    } else if (event.keyCode === 27) {
      document.querySelector(".close").click();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  function swichModal(mode) {
    let n = filteredList.indexOf(modalCurrent);
    if (mode === "prev") {
      if (n > 0) {
        setModalCurrent(filteredList[n - 1]);
      }
    }
    if (mode === "next") {
      if (n + 1 < filteredList.length) {
        setModalCurrent(filteredList[n + 1]);
      }
    }
  }

  return (
    <div className={modal ? "modal_container show" : "modal_container"}>
      <div className="modal_bg" onClick={() => setModal(false)}></div>
      <div className="modal_inner">
        <div>
          <div>
            <img
              src={`/material/images/wave/${modalCurrent.code}.jpg`}
              alt=""
            />
          </div>
          <div>
            <img
              src={`/material/images/flat/${modalCurrent.code}.jpg`}
              alt=""
            />
          </div>
        </div>
        <h2>
          {modalCurrent.series}
          <span>シリーズ</span>
          <small>
            {modalCurrent.kiji && modalCurrent.kiji.split(" ")[0]}
            <br className="sp" />
            {modalCurrent.kiji && modalCurrent.kiji.split(" ")[1]}
          </small>
        </h2>
        <span className="close" onClick={() => setModal(false)}></span>
        <p>
          {modalCurrent.zero}
          <small>ランク</small>
        </p>
        <div className="navigation">
          <span className="prev" onClick={() => swichModal("prev")}></span>
          <div>
            <b>{filteredList.indexOf(modalCurrent) + 1}</b>/
            <span>{filteredList.length}</span>
          </div>
          <span className="next" onClick={() => swichModal("next")}></span>
        </div>
      </div>
    </div>
  );
}

export default memo(Modal);
